/* global axios */
import ApiClient from './ApiClient';

class LeadScoresAPI extends ApiClient {
  constructor() {
    super('pipeline_cards', { accountScoped: true });
  }

  recalculate(pipelineCardId) {
    return axios.post(`${this.url}/${pipelineCardId}/lead_scores/recalculate`);
  }

  override(pipelineCardId, score) {
    return axios.post(`${this.url}/${pipelineCardId}/lead_scores/override`, {
      score,
    });
  }

  getDistribution() {
    // Distribution endpoint is under /pipeline namespace, not /pipeline_cards
    const baseUrl = this.url.replace('/pipeline_cards', '/pipeline');
    return axios.get(`${baseUrl}/lead_scores/distribution`);
  }
}

export default new LeadScoresAPI();
